import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import "../css/signin.css";
import { toast } from "react-toastify";

const SignIn = () => {
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState(""); // email yahan store ho rahi hai
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [login, setLogin] = useState({
        username: "",
        id: "",
        token: "",
    });

    const Api = process.env.REACT_APP_BACKEND_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const formData = new FormData();
            formData.append("username", username); // email -> username
            formData.append("password", password);

            const response = await fetch(`${Api}auth/login`, {
                method: "POST",
                body: formData,
            });

            const result = await response.json();

            if (response.status === 403) {
                toast.error("Access Denied: Only Admin can access this portal");
                return;
            }

            if (!response.ok) {
                toast.error(result.detail || result.message || "Login Failed");
                return;
            }

            // Check if the user is an admin
            if (result.user?.account_type !== "admin") {
                toast.error("Unauthorized: Only Admin can access this portal");
                return;
            }

            localStorage.setItem("access_token", result.access_token);
            localStorage.setItem("id", result.user?.id);
            localStorage.setItem("first_name", result.user?.first_name || result.user?.username || "Admin");
            localStorage.setItem("email", result.user?.email || username || "");
            localStorage.setItem("role", result.user?.account_type);
            
            localStorage.setItem("role", result.user?.account_type);

            toast.success("Login Successful");
            navigate("/dashboard");

        } catch (error) {
            console.error("Login Error:", error);
            toast.error("Internal Server Error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="signin-container">
            <div className="signin-left">
                <div className="head">
                    <h1 className="fanatech">Fanatech</h1>
                    <p className="admin">Admin</p>
                </div>
                
                <div className="signin-logo-wrapper" style={{ margin: "60px 0", display: "flex", justifyContent: "center", width: "100%" }}>
                    <img 
                        src="/logo.png" 
                        alt="Fanatech Logo" 
                        style={{ 
                            width: "200px", 
                            height: "auto",
                            filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.1))" // Added a subtle shadow for depth
                        }} 
                    />
                </div>

                <div className="bottom">
                    <h2 className="welcome">Welcome Back</h2>
                    <p className="note">
                        Manage bookings, stock and expenses with ease.
                    </p>
                </div>
            </div>

            <div className="signin-right">
                <div className="form-signin">
                    <div className="heading">
                        <div className="mobile-logo-header">
                            <img src="/logo.png" alt="Fanatech Logo" className="mobile-logo" />
                        </div>
                        <h1 className="signin">Sign in</h1>
                        <p className="note-signin">
                            Access your Fanatech admin dashboard.
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="form">
                        <div className="input-group">
                            <label>Email</label>
                            <div className="input-wrapper">
                                <FiMail className="input-icon" />
                                <input
                                    type="email"
                                    placeholder="you@company.com"
                                    className="form-input"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="password-header">
                                <label>Password</label>
                            </div>
                            <div className="input-wrapper">
                                <FiLock className="input-icon" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="••••••••"
                                    className="form-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="eye-icon"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FiEyeOff /> : <FiEye />}
                                </button>
                            </div>
                        </div>

                        <button type="submit" className="submit-btn" disabled={isLoading}>
                            {isLoading ? "Signing in..." : "Sign in"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignIn;
